import React from 'react';
import { Link } from 'react-router-dom';
import { Box, ButtonBase, Typography } from '@mui/material';
import { alpha, darken } from '@mui/material/styles';

export default function ToolTile({ title, to, icon }) {
  return (
    <ButtonBase component={Link} to={to} sx={(theme) => ({
      display: 'flex', flexDirection: 'column', alignItems: 'stretch', alignSelf: 'start', gap: 2.5,
      minWidth: 0, width: '100%', textDecoration: 'none', borderRadius: 6,
      '& .tool-tile-icon': {
        transition: 'transform 150ms ease, box-shadow 150ms ease',
        boxShadow: `0 6px 0 ${darken(theme.palette.primary.main, 0.65)}, 0 0 20px ${alpha(theme.palette.secondary.main, 0.12)}`,
      },
      '&:hover .tool-tile-icon': { transform: 'translateY(-3px)', boxShadow: `0 9px 0 ${darken(theme.palette.primary.main, 0.65)}, 0 0 26px ${alpha(theme.palette.primary.main, 0.18)}` },
      '&:active .tool-tile-icon': { transform: 'translateY(4px)', boxShadow: 'none' },
      '&:focus-visible .tool-tile-icon': { outline: `3px solid ${theme.palette.secondary.main}`, outlineOffset: 5 },
      '@media (prefers-reduced-motion: reduce)': { '& .tool-tile-icon': { transition: 'none' }, '&:hover .tool-tile-icon': { transform: 'none' } },
    })}>
      <Box className="tool-tile-icon" aria-hidden="true" sx={(theme) => ({
        width: '100%', aspectRatio: '1', display: 'grid', placeItems: 'center', borderRadius: 6,
        border: `3px solid ${theme.palette.primary.main}`, color: 'primary.main',
        background: `linear-gradient(145deg, ${alpha(theme.palette.primary.main, 0.12)}, ${theme.palette.background.default} 75%)`,
        '& svg': { width: { xs: 48, sm: 64 }, height: { xs: 48, sm: 64 } },
      })}>{icon}</Box>
      <Typography component="h2" sx={{ fontSize: { xs: '0.7rem', sm: '0.85rem' }, lineHeight: 1.9, textAlign: 'center', m: 0 }}>{title}</Typography>
    </ButtonBase>
  );
}
